import { render, staticRenderFns } from "./RaceList.vue?vue&type=template&id=588fb7c6&"
import script from "./RaceList.vue?vue&type=script&lang=js&"
export * from "./RaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports